var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99998 15.2499C12.4518 15.2499 15.25 12.4517 15.25 8.99992C15.25 5.54814 12.4518 2.74992 8.99998 2.74992C5.5482 2.74992 2.74998 5.54814 2.74998 8.99992C2.74998 12.4517 5.5482 15.2499 8.99998 15.2499ZM8.99998 16.2916C13.0271 16.2916 16.2916 13.027 16.2916 8.99992C16.2916 4.97284 13.0271 1.70825 8.99998 1.70825C4.9729 1.70825 1.70831 4.97284 1.70831 8.99992C1.70831 13.027 4.9729 16.2916 8.99998 16.2916Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69443 11.7777V8.99993C9.69443 8.6164 9.38352 8.30549 8.99999 8.30549C8.61646 8.30549 8.30554 8.6164 8.30554 8.99993V11.7777C8.30554 12.1612 8.61646 12.4722 8.99999 12.4722C9.38352 12.4722 9.69443 12.1612 9.69443 11.7777Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30554 6.22215C8.30554 6.60569 8.61646 6.9166 8.99999 6.9166C9.38352 6.9166 9.69443 6.60569 9.69443 6.22215C9.69443 5.83862 9.38352 5.52771 8.99999 5.52771C8.61646 5.52771 8.30554 5.83862 8.30554 6.22215Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ef8e13f8.svg";
export { ForwardRef as ReactComponent };